/**
 * Easing equation function for a cubic (t^3) easing in: accelerating from zero velocity.
 */
export function easeInOutCubic(x: number) {
  return x < 0.5 ? 4 * x * x * x : 1 - (-2 * x + 2) ** 3 / 2
}
